import React from 'react';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CopyIcon,
    IconButton,
    XStack,
    YStack,
} from 'smoothie';

interface DraftedHandoffCardProps {
    label: string;
    title?: string;
    body: string;
    actionLabel: string;
    actionDisabled?: boolean;
    /** Omit to render the action button disabled (read-only views). */
    onAction?: () => void;
    /** Omit to hide the copy button. */
    onCopy?: () => void;
}

export const DraftedHandoffCard = ({
    label,
    title,
    body,
    actionLabel,
    actionDisabled = false,
    onAction,
    onCopy,
}: DraftedHandoffCardProps) => (
    <YStack width="100%" gap={16}>
        <YStack gap={8} width="100%">
            <BodySmallRegular color="$gray1000">{label}</BodySmallRegular>
            {title != null && title.trim() !== '' ? (
                <BodyMediumEmphasized color="$black">
                    {title}
                </BodyMediumEmphasized>
            ) : null}
            <BodyMediumRegular color="$black">{body}</BodyMediumRegular>
        </YStack>
        <XStack gap={12} alignItems="center">
            <Button
                variant={ButtonVariant.SECONDARY_ALT}
                size={ButtonSize.SMALL}
                text={actionLabel}
                disabled={actionDisabled || onAction == null}
                width="auto"
                onPress={onAction}
            />
            {onCopy != null ? (
                <IconButton
                    variant="secondary-alt"
                    icon={CopyIcon}
                    onPress={onCopy}
                />
            ) : null}
        </XStack>
    </YStack>
);
